import React from 'react';

const accountsData = [
  { id: 1, name: 'Designated Beneficiary IN ...690' },
  { id: 2, name: 'Individual ...878' },
  { id: 3, name: 'Individual ...790' },
];

export default function AccountSelectionSch({ selectedAccounts, setSelectedAccounts, onNext, onBack }) {
  function toggleAccount(id) {
    if (selectedAccounts.includes(id)) {
      setSelectedAccounts(selectedAccounts.filter(accId => accId !== id));
    } else {
      setSelectedAccounts([...selectedAccounts, id]);
    }
  }

  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
      {/* โลโก้อยู่มุมซ้ายบน */}
      <img
        src="/photo/charlesschwab.jpg"
        alt="Charles Schwab"
        className="absolute top-4 left-4 w-16"
      />

      <div className="max-w-xl mx-auto mt-10 p-6 bg-white rounded-lg relative">
        <h2 className="text-xl font-semibold mb-4">Select your Schwab accounts to link</h2>
        <p className="mb-6">Select your Schwab account to link to Quantum Flo Auto Algo.</p>

        <div className="mb-6">
          {accountsData.map(account => (
            <label
              key={account.id}
              className="block mb-2 cursor-pointer select-none"
            >
              <input
                type="checkbox"
                checked={selectedAccounts.includes(account.id)}
                onChange={() => toggleAccount(account.id)}
                className="form-checkbox h-5 w-5 text-blue-600 mr-2 align-middle"
              />
              <span className="align-middle">{account.name}</span>
            </label>
          ))}
        </div>

        <div className="flex justify-between">
          <button
            onClick={onBack}
            className="py-2 px-6 border rounded hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={onNext}
            disabled={selectedAccounts.length === 0}
            className={`py-2 px-6 rounded text-white ${
              selectedAccounts.length === 0
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-green-600 hover:bg-green-700'
            }`}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}

